var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('UiIcon',{class:_vm.$style.icon,attrs:{"color-inheritance":true,"name":"star"}}),_c('span',{class:_vm.$style.value},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }